import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit, Renderer2 } from '@angular/core';
import { MatIconRegistry, SafeResourceUrlWithIconOptions } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService, rateNowAdminUserTheme } from '@nx-ratenow/core/config';
import { DataAccessFaceBookService } from '@nx-ratenow/core/data-access-facebook';
import { LayoutService, SplashScreenService } from '@nx-ratenow/core/data-access-layaout';
import { NavigationServiceAdminWeb } from '@nx-ratenow/core/data-access-navigation';
import { RbacService } from '@nx-ratenow/core/data-access-role-access';
import { UserFacade } from '@nx-ratenow/core/data-access-user';
import { Settings } from 'luxon';
import { filter } from 'rxjs/operators';


@UntilDestroy()
@Component({
  standalone: false,
  selector: 'nx-ratenow-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(
    private configService: ConfigService,
    private renderer: Renderer2,
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private navigationServiceAdminWeb: NavigationServiceAdminWeb,
    private splashScreenService: SplashScreenService,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private readonly translate: TranslateService,
    private dataAccessFaceBookService: DataAccessFaceBookService,
    private userFacade: UserFacade,
    private rbacService: RbacService,
    private router: Router
  ) {
    this.configService.updateConfig(rateNowAdminUserTheme);

    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    // TODO: Move this into project.json or a service
    this.matIconRegistry.addSvgIconResolver((name: string, namespace: string): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
      switch (namespace) {
        case 'mat':
          return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/material-design-icons/two-tone/${name}.svg`);
        case 'logo':
          return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/logos/${name}.svg`);
        case 'flag':
          return this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/img/icons/flags/${name}.svg`);
        default:
          return null;
      }
    });

    const initParams = {
      appId: '951528943222927',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v25.0'
    };

    dataAccessFaceBookService.init(initParams);
  }

  ngOnInit(): void {
    this.document.documentElement.lang = this.translate.currentLang;
    this.translate.onLangChange.subscribe((lang) => (this.document.documentElement.lang = lang.lang));

    this.userFacade.userLogged$.pipe(filter((val) => val != undefined)).subscribe((userLogged) => {
      this.rbacService.setAuthorities(userLogged.authorities);

      // if (userLogged.authorities.includes('access_all')) { //TODO: Cambiar checke de la authority
      //   this.router.navigateByUrl('/dashboard');
      // } else {
      //   this.router.navigateByUrl('/account-settings');
      // }
    });
  }
}
